import React, { useState } from "react";
import {
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  IconButton,
  Modal,
  Backdrop,
  Fade,
} from "@material-ui/core";
import YearFilter from "./YearFilter";
import filter from "../../../image/filter.svg";

const YearFilterMobile = ({ uniqueYears, setSelectedYear, selectedYear }) => {
  const [open, setOpen] = useState(false); 

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <img src={filter} alt="" style={{ marginRight: "20px" }} 
      onClick={handleOpen}
      />
      <Box
        display="flex"
        alignItems="center"
        border="1.5px solid #243B55"
        sx={{
          borderRadius: "8px",
          overflow: "hidden", 
          p: 0.5,
          width: 300,
        }}
      >
        <FormControl onClick={handleOpen} fullWidth>
          {selectedYear.length > 0 ? (
            <MenuItem value={selectedYear}>{selectedYear.join(", ")}</MenuItem>
          ) : (
            <div style={{ padding: "7px",color:'#243B55',fontWeight:700 }}>-Select Year-</div>
          )}
        </FormControl>
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={open}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 300,
              // bgcolor: "white",
              boxShadow: 24,
              p: 3,
              borderRadius: 2,
            }}
          >
            <YearFilter
              uniqueYears={uniqueYears}
              setSelectedYear={setSelectedYear}
              selectedYear={selectedYear}
            />
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default YearFilterMobile;
